import levels from './levels';

const getMetricTypes = () => ({...levels});

export default getMetricTypes;
